import { Suspense } from 'react';

import { lazyRetry } from '@cast/utils';

import { SuspenseLoader } from 'components/loaders';

const SplitMeCustomDashboardsController = lazyRetry(
  () =>
    import('@cast/split-me/pages/custom-dashboards/CustomDashboardsController')
);

export const CustomDashboardsController = () => (
  <Suspense fallback={<SuspenseLoader />}>
    <SplitMeCustomDashboardsController />
  </Suspense>
);
